import React from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';
import ForgotPasswordCTA from '../ForgotPasswordCTA';

import Style from './ChangePassword.module.scss';

const ChangePassword = ({
  changePasswordGenericError = '',
  changePasswordNewPassword = '',
  changePasswordNewPasswordError = null,
  changePasswordPassword = '',
  changePasswordPasswordError = null,
  changePasswordShowNewPassword = null,
  changePasswordShowPassword = null,
  forgotPasswordCTAProps = {
    containerClass: '',
    linkClass: '',
    linkText: '',
    onClick: () => {},
    text: '',
    theme: '',
  },
  headerProps = {},
  language = {
    profile_currentPwInputPlaceholder: '',
    profile_newPwInputPlaceholder: '',
    profile_passwordRequirementsText: '',
    profileEdit_submitButton: '',
    profile_passwordInvalidError: '',
  },
  onChangePassword = () => {},
  onFieldChange = e => e,
}) => {
  const {
    profile_currentPwInputPlaceholder: currentPlaceholder,
    profile_newPwInputPlaceholder: newPlaceholder,
    profile_passwordRequirementsText: passwordRequirementText,
    profileEdit_submitButton: submitButtonText,
    profile_passwordInvalidError: passwordInvalidError,
  } = language || {};

  let changePasswordInput = React.createRef();
  let changePasswordInputNew = React.createRef();

  const handleOnChangePasswordInput = e => {
    onFieldChange(e);
    if (changePasswordInput.current) {
      changePasswordInput.current.focus();
    }
  };

  const handleOnChangePasswordInputNew = e => {
    onFieldChange(e);
    if (changePasswordInputNew.current) {
      changePasswordInputNew.current.focus();
    }
  };

  const passwordOldVisibility = changePasswordShowPassword ? 'text' : 'password';
  const passwordNewVisibility = changePasswordShowNewPassword ? 'text' : 'password';

  let passwordErrorText;
  let passwordNewErrorText;

  // local error checking
  if (changePasswordPasswordError) {
    passwordErrorText = passwordInvalidError;
  }
  if (changePasswordNewPasswordError) {
    passwordNewErrorText = passwordInvalidError;
  }

  return (
    <main className={Style.changePassword}>
      <Header {...headerProps} />
      <div className={Style.changePasswordContainer}>
        <h1>Change Password</h1>
        <div className={Style.error}>{changePasswordGenericError}</div>
        <div className={Style.signupPasswordContainer}>
          <input
            className={Style.inputField}
            type={passwordOldVisibility}
            name="changePasswordPassword"
            placeholder={currentPlaceholder}
            value={changePasswordPassword}
            onChange={onFieldChange}
            ref={input => {
              changePasswordInput = input;
            }}
            autoCapitalize="none"
            autoComplete="off"
            autoCorrect="off"
            spellCheck={false}
          />
          <label className={Style.passwordLabel}>
            <input
              className={Style.inputField}
              name="changePasswordShowPassword"
              type="checkbox"
              value={changePasswordShowPassword}
              onChange={handleOnChangePasswordInput}
            />
            <span />
          </label>
        </div>
        <div className={Style.error}>{passwordErrorText}</div>
        <div className={Style.signupPasswordContainer}>
          <input
            className={Style.inputField}
            type={passwordNewVisibility}
            name="changePasswordNewPassword"
            placeholder={newPlaceholder}
            value={changePasswordNewPassword}
            onChange={onFieldChange}
            ref={input => {
              changePasswordInputNew = input;
            }}
            autoCapitalize="none"
            autoComplete="off"
            autoCorrect="off"
            spellCheck={false}
          />
          <label className={Style.passwordLabel}>
            <input
              className={Style.inputField}
              name="changePasswordShowNewPassword"
              type="checkbox"
              value={changePasswordShowNewPassword}
              onChange={handleOnChangePasswordInputNew}
            />
            <span />
          </label>
        </div>
        <div className={Style.error}>{passwordNewErrorText}</div>
        <div className={Style.changePasswordRequirements}>{passwordRequirementText}</div>
        <ForgotPasswordCTA {...forgotPasswordCTAProps} />
        <button className={Style.btnPrimary} onClick={onChangePassword}>
          {submitButtonText}
        </button>
      </div>
    </main>
  );
};

ChangePassword.propTypes = {
  changePasswordGenericError: PropTypes.string,
  changePasswordNewPassword: PropTypes.string.isRequired,
  changePasswordNewPasswordError: PropTypes.bool,
  changePasswordPassword: PropTypes.string.isRequired,
  changePasswordPasswordError: PropTypes.bool,
  changePasswordShowNewPassword: PropTypes.bool.isRequired,
  changePasswordShowPassword: PropTypes.bool.isRequired,
  forgotPasswordCTAProps: PropTypes.shape({}).isRequired,
  headerProps: PropTypes.shape({}).isRequired,
  language: PropTypes.shape({}).isRequired,
  onChangePassword: PropTypes.func.isRequired,
  onChangePasswordBackClick: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
};

export default ChangePassword;
